import React, { useEffect, useState } from 'react';

import { Layer, Source, useMap, Popup } from 'react-map-gl';
import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';


import { callGetJson } from 'handimap-react-lib/api/jsonConfApi';


export const ZonesLayer = () => {

  const {mymap} = useMap();
  const { t } = useTranslation();

  const [zoomConf, setZoomConf] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [lngPopup, setLngPopup] = useState(null);
  const [latPopup, setLatPopup] = useState(null);
  const [popupTitle, setPopupTitle] = useState('');
  const [siteCoords, setSiteCoords] = useState([]);
  const [siteZoom, setSiteZoom] = useState(14);

  useEffect(() => {
    if (mymap !== undefined && mymap !== null) {
      callGetJson('custom_zoom_zone_button.json').then(
        result => {
          result.map((conf, i) => {
            if (conf.image && !mymap.hasImage(conf.zone)) {
              mymap.loadImage(conf.image, (error, image) => {
                mymap.addImage(conf.zone, image, { sdf: false });
              });
            }
            mymap.on('mousedown', `zone_${i}`, (e) => openPopup(e));
            mymap.on('mouseenter', `zone_${i}`, () => mymap.getCanvas().style.cursor = 'pointer');
            mymap.on('mouseleave', `zone_${i}`, () => mymap.getCanvas().style.cursor = 'auto');
          });
          setZoomConf(result);
        });
    }
    return () => {
      setZoomConf([]);
    };
  }, [mymap]);

  const openPopup = (e) => {
    setLngPopup(e.lngLat.lng);
    setLatPopup(e.lngLat.lat);
    setPopupTitle(e.features[0].properties.zone);
    setSiteCoords(e.features[0].geometry.coordinates);
    setSiteZoom(e.features[0].properties.zoom);
    setShowPopup(true);
  };

  const gotToSite = () => {
    setShowPopup(false);
    mymap.flyTo({center: siteCoords, zoom: siteZoom, duration: 2500});
  };

  return (
    <>
      {zoomConf.map((conf, i) => {
        return (
          <Source  
            id={`zone_${i}`}
            key={`zone_${i}`}
            type="geojson"
            data={{
              'type': 'Feature',
              'geometry': {
                'type': 'Point',
                'coordinates': conf.center
              },
              'properties': {
                'zone': conf.zone,
                'zoom': conf.zoom
              }
            }}
          >
            <Layer 
              id={`zone_${i}`}
              maxzoom={11}
              minzoom={7}
              type="symbol"
              layout={{
                'icon-size': [
                  'interpolate',
                  ['linear'],
                  ['zoom'],
                  6, 0.04,
                  12, 0.08
                ],
                'icon-image': conf.zone,
                'icon-allow-overlap': true,
                'symbol-sort-key': 0
              }}
            />
          </Source>
        );
      })}
      {showPopup && <Popup
        latitude={latPopup}
        longitude={lngPopup}
        closeButton={true}
        closeOnClick={false}
        maxWidth="350px"
        onClose={() => setShowPopup(false)}
      >
        <div style={{alignItems: 'center', display:'flex', flexDirection:'column'}}>
          <Typography component="p" sx={{fontFamily: 'Luciole-bold', fontSize:'1.1em'}}>
            {popupTitle}
          </Typography>
          <Button variant='text' onClick={() => gotToSite()}>
            {t('zone-layer.button')}
          </Button>
        </div>
      </Popup>}
    </>
  );
};

